<template>
  <section>
    <span class="text">{{ $t('home.main.badges.new') }}</span>
  </section>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      required: false,
      default: 50
    },
    height: {
      type: Number,
      required: false,
      default: 50
    }
  }
};
</script>

<style scoped>
.text {
  color: white;
  font-size: 14px;
  background: #3a73e3;
  padding: 0px 5px;
  border-radius: 4px;
  margin-left: 5px;
  position: relative;
}
.text::after {
  content: ' ';
  position: absolute;
  top: 50%;
  right: 100%; /* To the left of the tooltip */
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent #3a73e3 transparent transparent;
}
.icon {
  position: relative;
  top: 4px;
  left: 0;
  z-index: 0;
}
</style>
